import * as DatepickerActions from '../actions/datepickers';
import * as FindUserActions from '../actions/findUser';
import * as ActivityCreators from './activity';

import ReduxAction from '../interfaces/ReduxAction';

export function activityMountTab (): ReduxAction {
  return (dispatch): void => {
    dispatch(DatepickerActions.fetchDatepickersShowAction());
    dispatch(FindUserActions.fetchActiveTabAction(1));
    dispatch(ActivityCreators.activity());
  };
}
